import { createSelector } from '@reduxjs/toolkit'

import { selectDownload } from './selectDownload'

export const selectDownloadError = createSelector(selectDownload, (download) => download.error)
